import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initPixel, trackPixelEvent } from '../utils/pixel';

export const usePixel = () => {
  const location = useLocation();

  // Initialize Pixel on mount
  useEffect(() => {
    initPixel();
  }, []);

  // Track PageView on route change
  useEffect(() => {
    trackPixelEvent('PageView');
  }, [location.pathname]);

  return { trackPixelEvent };
};
